'use strict';

// ── Tab navigation ────────────────────────
(function () {
  var btns = document.querySelectorAll('.gpdp-tab-btn');
  var panels = document.querySelectorAll('.gpdp-tab-panel');
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btns.forEach(function (b) { b.classList.remove('active'); });
      panels.forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById('tab-' + btn.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });
})();

// ── Variant picker ──────────────────────
(function () {
  var jsonEl = document.getElementById('gpdp-variants-json');
  if (!jsonEl) return;
  var variants = JSON.parse(jsonEl.textContent);
  var selectedOptions = {};
  var mainIdInput   = document.getElementById('gpdp-variant-id');
  var stickyIdInput = document.getElementById('gpdp-sticky-variant-id');
  var priceEl          = document.getElementById('gpdp-price');
  var comparePriceEl   = document.getElementById('gpdp-compare-price');
  var stickyPriceEl    = document.getElementById('gpdp-sticky-price');
  var atcBtn           = document.getElementById('gpdp-hero-atc');

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return !selectedOptions.hasOwnProperty(i) || selectedOptions[i] === opt;
      });
    });
  }

  function updateUI() {
    var v = findVariant();
    if (!v) return;
    if (mainIdInput)   mainIdInput.value   = v.id;
    if (stickyIdInput) stickyIdInput.value = v.id;
    if (priceEl)       priceEl.textContent       = v.price_formatted;
    if (stickyPriceEl) stickyPriceEl.textContent = v.price_formatted;
    if (comparePriceEl) {
      if (v.compare_at_price > v.price) {
        comparePriceEl.textContent = v.compare_at_price_formatted;
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
  }

  document.querySelectorAll('.gpdp-opt-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.gpdp-opt-group');
      if (!group) return;
      group.querySelectorAll('.gpdp-opt-btn').forEach(function (b) { b.classList.remove('sel'); });
      btn.classList.add('sel');
      selectedOptions[parseInt(btn.dataset.option, 10)] = btn.dataset.value;
      updateUI();
    });
  });

  // Auto-select first option in each group
  document.querySelectorAll('.gpdp-opt-group').forEach(function (group) {
    var first = group.querySelector('.gpdp-opt-btn');
    if (first) first.click();
  });
})();

// ── Sticky ATC bar ──────────────────────
(function () {
  var heroAtc   = document.getElementById('gpdp-hero-atc');
  var stickyBar = document.getElementById('gpdp-sticky-bar');
  if (!heroAtc || !stickyBar) return;
  var io = new IntersectionObserver(
    function (entries) { stickyBar.classList.toggle('show', !entries[0].isIntersecting); },
    { rootMargin: '-80px 0px 0px 0px' }
  );
  io.observe(heroAtc);
})();
